const accordion = () => {
  document.querySelectorAll('.js-accordion').forEach(($accordion) => {
    $accordion.addEventListener('click', () => {
      $accordion.classList.toggle('is-active');
    });
  });
};

export default accordion;